/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ done: NonNullable<unknown> }} Wrapped_Sessions_CountInputs */

const en_us2_wrapped_sessions_count = /** @type {(inputs: Wrapped_Sessions_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.done === 1 || i?.done === "1")) return /** @type {LocalizedString} */ (`1 workout`);
	return /** @type {LocalizedString} */ (`${i?.done} workouts`)
	
};

const pt_br2_wrapped_sessions_count = /** @type {(inputs: Wrapped_Sessions_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.done === 1 || i?.done === "1")) return /** @type {LocalizedString} */ (`1 treino`);
	return /** @type {LocalizedString} */ (`${i?.done} treinos`)
	
};

const es_419_wrapped_sessions_count = /** @type {(inputs: Wrapped_Sessions_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.done === 1 || i?.done === "1")) return /** @type {LocalizedString} */ (`1 entrenamiento`);
	return /** @type {LocalizedString} */ (`${i?.done} entrenamientos`)
	
};

const pt_pt2_wrapped_sessions_count = /** @type {(inputs: Wrapped_Sessions_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.done === 1 || i?.done === "1")) return /** @type {LocalizedString} */ (`1 treino`);
	return /** @type {LocalizedString} */ (`${i?.done} treinos`)
	
};

const fr_fr2_wrapped_sessions_count = /** @type {(inputs: Wrapped_Sessions_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.done === 0 || i?.done === "0")) return /** @type {LocalizedString} */ (`0 séance`);
	if ((i?.done === 1 || i?.done === "1")) return /** @type {LocalizedString} */ (`1 séance`);
	return /** @type {LocalizedString} */ (`${i?.done} séances`)
	
};

const de_de2_wrapped_sessions_count = /** @type {(inputs: Wrapped_Sessions_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.done === 1 || i?.done === "1")) return /** @type {LocalizedString} */ (`1 Training`);
	return /** @type {LocalizedString} */ (`${i?.done} Trainings`)
	
};

const it_it2_wrapped_sessions_count = /** @type {(inputs: Wrapped_Sessions_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.done === 1 || i?.done === "1")) return /** @type {LocalizedString} */ (`1 allenamento`);
	return /** @type {LocalizedString} */ (`${i?.done} allenamenti`)
	
};

/**
* | done | output |
* | --- | --- |
* | "1" | "1 workout" |
* | * | "{done} workouts" |
*
* @param {Wrapped_Sessions_CountInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_sessions_count = /** @type {((inputs: Wrapped_Sessions_CountInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Sessions_CountInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_sessions_count(inputs)
	if (locale === "es-419") return es_419_wrapped_sessions_count(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_sessions_count(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_sessions_count(inputs)
	if (locale === "de-DE") return de_de2_wrapped_sessions_count(inputs)
	if (locale === "it-IT") return it_it2_wrapped_sessions_count(inputs)
	return en_us2_wrapped_sessions_count(inputs)
});
export { wrapped_sessions_count as "wrapped.sessions_count" }